import { Col, Layout, Row } from "antd";
import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getShareableBrands,
  checkSharableLink,
  getUserPrivilegesAPI,
} from "../../../redux/actions/ApiCall/apiCall";
import Dashboard from "../dashboard";
import { setConfigData } from "../../../redux/actions/ApiCall";
import PasswordModal from "./PasswordModal";
import {
  getConfigurationFiltersAPI,
  setWidgetMakerGraphConditionConfiguration,
} from "../../../redux/actions/WidgetMaker/WidgetAPI";
import { getPaneIndex } from "../../../redux/constants";
import { setActiveSectionId } from "../../../redux/actions/dashboard/Tab1";
import { setActiveSectionKey } from "../../../redux/actions/section/section";
import LinkNotFound from "./LinkNotFound";

export const ShareableComponent = () => {
  const dispatch = useDispatch();
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const config = useSelector((state) => state.apiCall.config);

  const shareLoaders = useSelector((state) => state.ApiCall.shareLoaders);

  const shareableLinkStatus = useSelector(
    (state) => state.ApiCall.shareableLinkStatus
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );
  const configuration_data = useSelector(
    (state) => state.WidgetAPI.configuration_data
  );
  const loadingConfig = useSelector((state) => state.apiCall.loaderConfig);
  const authParams = useSelector((state) => state.Authentication.authParams);

  const [passwordModalVisible, setPasswordModalVisible] = useState(false);
  const [passSubmit, setPassSubmit] = useState(false);
  const [shareTypeAPICalled, setShareTypeAPICalled] = useState(false);

  var urlParams; // url encrypted parameters

  const passwordStatus = useSelector((state) => state.ApiCall.passwordStatus);
  const panes = useSelector((state) => state.Tab1.panes);
  const activeKey = useSelector((state) => state.Tab1.activeKey);
  let index = getPaneIndex(panes, activeKey);

  useEffect(() => {
    if (passwordStatus === "Invalid password") {
      setPassSubmit(false);
    }
  }, [passSubmit]);

  //Function to get url params from URL and set it to urlParams variable
  (window.onpopstate = function () {
    var match,
      pl = /\+/g, // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) {
        return decodeURIComponent(s.replace(pl, " "));
      },
      query = window.location.search.substring(1);

    urlParams = {};
    while ((match = search.exec(query)))
      urlParams[decode(match[1])] = decode(match[2]);
  })();

  // Only for initial render to get user privileges for share link
  useEffect(() => {
    // Get User Privileges API
    if (!share_workspace_privileges) {
      dispatch(
        getUserPrivilegesAPI(
          null,
          urlParams?.share_id ? urlParams?.share_id : null
        )
      );
    }
  }, []);

  // check password protected or not
  useEffect(() => {
    !graphConditionConfig &&
      dispatch(setWidgetMakerGraphConditionConfiguration(true));

    if (!shareableLinkStatus && !shareTypeAPICalled) {
      setShareTypeAPICalled(true);
      dispatch(checkSharableLink(urlParams.share_id));
    }

    if (shareableLinkStatus === true) {
      setPasswordModalVisible(true);
    }

    if (shareableLinkStatus === false && graphConditionConfig) {
      const password = sessionStorage.getItem("shareLinkPassword");

      !shareBrands &&
        urlParams?.share_id &&
        dispatch(
          getShareableBrands(
            urlParams.share_id,
            shareLoaders,
            password,
            graphConditionConfig
          )
        );

      // On refresh browser reset Active Section Key and Id
      shareBrands && dispatch(setActiveSectionKey(null));
      shareBrands && dispatch(setActiveSectionId(null, panes, index));
    }
    let share_id = urlParams?.share_id;
    // !config && dispatch(setConfigData(null, null, share_id));
    if (!configuration_data && !loadingConfig) {
      dispatch(getConfigurationFiltersAPI(authParams, null, share_id));
    }
  }, [shareableLinkStatus, shareBrands, graphConditionConfig]);

  const handleChangePasswordModal = (value) => {
    setPasswordModalVisible(value);
  };

  return !shareTemplateData ||
    shareTemplateData?.error_code === 501 ||
    shareTemplateData?.error_code === 602 ? (
    <div style={{ height: "100vh" }}>
      {shareableLinkStatus ? (
        <>
          <PasswordModal
            isModalShare={passwordModalVisible}
            handleChangeShare={handleChangePasswordModal}
            passSubmit={passSubmit}
            setPassSubmit={setPassSubmit}
          />
        </>
      ) : (
        <>
          {shareTemplateData?.error_code === 501 ||
          shareTemplateData?.error_code === 602 ? (
            <LinkNotFound errorCode={shareTemplateData?.error_code} />
          ) : (
            <>
              <div className="d-flex h-100 justify-content-center align-items-center">
                <div className="loader">
                  <div className="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  ) : (
    <Layout>
      <Row>
        <Col span={24}>
          <Dashboard shareTemplateData={shareTemplateData} share={true} />
        </Col>
      </Row>
    </Layout>
  );
};
